import { IResidenceLocation } from "../interfaces/residenceLocation";
import { IFormValues as IUserFormValues } from "../components/UserForm";
import accessList from "../assets/json/accessList.json";
import { accessListType } from "../constants/enums";

export class User {
  mobile: string;
  ssn: string;
  name: string;
  location: string;
  accessList: Array<AccessItem>;
  hasError: boolean;
  sessionId: string;
  encodedSessionId: string;
  loginType: "sampling" | "vaccination";
  isRapidTestLocation: boolean;
  allowSampleTypeConversion: boolean;

  constructor(user: any) {
    this.mobile = user !== undefined ? user["mobile"] : null;
    this.ssn = user !== undefined ? user["ssn"] : null;
    this.name = user !== undefined ? user["name"] : null;
    this.location = user !== undefined ? user["location"] : null;
    this.accessList =
      user !== undefined
        ? user.accessList && user.accessList.map((i: any) => new AccessItem(i))
        : null;
    this.hasError = user !== undefined ? user["hasError"] : null;
    this.sessionId = user !== undefined ? user.sessionId : "";
    this.encodedSessionId = btoa(this.sessionId);
    this.encodedSessionId = btoa(this.sessionId);
    this.loginType =
      user !== undefined && user.loginType === "vaccination"
        ? "vaccination"
        : "sampling";
    this.isRapidTestLocation =
      user !== undefined ? user["isRapidTestLocation"] : false;
    this.allowSampleTypeConversion =
      user !== undefined ? user["allowSampleTypeConversion"] : false;
  }
}

export class AccessItem {
  id: number;
  description: string;

  constructor(accessItem: any) {
    this.id = accessItem !== undefined ? accessItem["id"] : 0;
    this.description =
      accessItem !== undefined ? accessItem["description"] : "";
  }
}

export class CreateUser {
  name: string;
  userAccesses: number[];
  userVaccinationRegionAccesses?: number[];
  userResidenceLocationAccesses?: number[];
  samplingLocationsAccesses?: number[];

  constructor(form: IUserFormValues) {
    const access = form.borderControlAccess
      .map((item) => parseInt(item.value))
      .concat(form.vaccinationAccess.map((item) => parseInt(item.value)));
    this.name = form.name;
    this.userAccesses = access;
    this.userVaccinationRegionAccesses = form.vaccinationRegions.map((r) =>
      parseInt(r.value)
    );
    this.userResidenceLocationAccesses = form.residenceLocations.map((r) =>
      parseInt(r.value)
    );
    this.samplingLocationsAccesses = form.samplingLocations.map((r) =>
      parseInt(r.value)
    );
  }
}

export class UserItem {
  name: string;
  ssn: string;
  access: {
    id: number;
    description: { is: string; en: string };
  }[];
  borderControlAccess: {
    id: number;
    description: { is: string; en: string };
  }[];
  vaccinationAccesses: {
    id: number;
    description: { is: string; en: string };
  }[];
  residenceLocations?: IResidenceLocation[];
  samplingLocations?: IResidenceLocation[];

  constructor(user: any) {
    const borderControlAccess: {
      id: number;
      description: { is: string; en: string };
    }[] = [];
    const vaccinationAccesses: {
      id: number;
      description: { is: string; en: string };
    }[] = [];

    if (user && user.userAccesses) {
      user.userAccesses.forEach((a: any) => {
        const accessItem = accessList.find(
          (item) =>
            item.id === a.id &&
            item.accessGroup === accessListType.BORDER_CONTROL
        );
        if (accessItem) {
          borderControlAccess.push(accessItem);
        } else {
        }
      });
      user.userAccesses.forEach((a: any) => {
        const accessItem = accessList.find(
          (item) =>
            item.id === a.id && item.accessGroup === accessListType.VACCINATION
        );
        if (accessItem) {
          vaccinationAccesses.push(accessItem);
        }
      });
    }
    this.borderControlAccess = borderControlAccess;
    this.vaccinationAccesses = vaccinationAccesses;
    // keeping all accesses in one array might be useful for other things
    this.access = this.borderControlAccess.concat(this.vaccinationAccesses);

    this.name = user && user.name ? user.name : "";
    this.ssn = user && user.ssn ? user.ssn : "";
    this.residenceLocations = user.residenceLocationListModel
      ? user.residenceLocationListModel
      : null;
    this.samplingLocations = user.samplingLocationAccesses
      ? user.samplingLocationAccesses
      : null;
  }
}

export class Location {
  id: string;
  key: string;
  label: string;

  constructor(location: any) {
    this.id = location && location.id;
    this.key = location && location.locationKey ? location.locationKey : "";
    this.label =
      location && location.locationDescription
        ? location.locationDescription
        : "";
  }
}

export class ErrorInfo {
  errorCode: number;
  errorMessage: string;

  constructor(errorCode: number, errorMessage: string) {
    this.errorCode = errorCode;
    this.errorMessage = errorMessage;
  }
}
